import React from 'react';
import { motion } from 'framer-motion';
const images = [{
  before: 'https://images.unsplash.com/photo-1556912167-45710a7156aa?auto=format&fit=crop&q=80&w=600',
  after: 'https://images.unsplash.com/photo-1588854337236-6889d631faa8?auto=format&fit=crop&q=80&w=600'
}, {
  before: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&q=80&w=600',
  after: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&q=80&w=600'
}, {
  before: 'https://images.pexels.com/photos/1080721/pexels-photo-1080721.jpeg?auto=compress&cs=tinysrgb&w=800',
  after: 'https://images.unsplash.com/photo-1588854337236-6889d631faa8?auto=format&fit=crop&q=80&w=600'
}, {
  before: 'https://cdn.magicpatterns.com/uploads/wSNwC24rbUf43YpFEv96V8/pexels-perqued-9757618.jpg',
  after: 'https://images.unsplash.com/photo-1588854337236-6889d631faa8?auto=format&fit=crop&q=80&w=600'
}, {
  before: 'https://images.pexels.com/photos/1080721/pexels-photo-1080721.jpeg?auto=compress&cs=tinysrgb&w=800',
  after: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&q=80&w=600'
}, {
  before: 'https://cdn.magicpatterns.com/uploads/edZNPSX49DtQo72wSY6B5B/pexels-curtis-adams-1694007-3935326.jpg',
  after: 'https://images.unsplash.com/photo-1588854337236-6889d631faa8?auto=format&fit=crop&q=80&w=600'
}];
export function MarqueeGallery() {
  return <div className="bg-charcoal py-8 overflow-hidden border-y-3 border-charcoal relative" data-id="element-78">
      <div className="absolute top-0 left-0 bottom-0 w-32 bg-gradient-to-r from-charcoal to-transparent z-10" data-id="element-79" />
      <div className="absolute top-0 right-0 bottom-0 w-32 bg-gradient-to-l from-charcoal to-transparent z-10" data-id="element-80" />

      <motion.div className="flex gap-8 whitespace-nowrap" animate={{
      x: [0, -1000]
    }} transition={{
      duration: 30,
      repeat: Infinity,
      ease: 'linear'
    }} data-id="element-81">
        {[...images, ...images].map((img, i) => <div key={i} className="flex gap-4 items-center shrink-0" data-id="element-82">
            <div className="relative group" data-id="element-83">
              <div className="w-48 h-32 border-2 border-white/20 overflow-hidden" data-id="element-84">
                <img src={img.before} alt="Before" className="w-full h-full object-cover grayscale" data-id="element-85" />
              </div>
              <div className="absolute top-2 left-2 bg-charcoal/80 text-[8px] text-white px-2 py-0.5 font-bold uppercase tracking-widest" data-id="element-86">
                Before
              </div>
            </div>
            <div className="text-espresso font-bold text-xl" data-id="element-87">→</div>
            <div className="relative" data-id="element-88">
              <div className="w-48 h-32 border-2 border-espresso overflow-hidden" data-id="element-89">
                <img src={img.after} alt="After" className="w-full h-full object-cover" data-id="element-90" />
              </div>
              <div className="absolute top-2 left-2 bg-espresso text-[8px] text-white px-2 py-0.5 font-bold uppercase tracking-widest" data-id="element-91">
                After
              </div>
            </div>
          </div>)}
      </motion.div>
    </div>;
}